import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ContentChild,
  TemplateRef,
  Directive,
} from '@angular/core';
import { LazyLoadEvent } from 'primeng';
import { IBaseFilter } from '../../interfaces/base-filter';
import { IPageResult } from '../../interfaces/page-result';
import { flatten } from '../../utils/flatten';
import { Observable, Subject, Subscription } from 'rxjs';
import { EventService, ReportService } from '../../services';
import { debounceTime } from 'rxjs/operators';

@Directive()
export class BaseReportComponent<TEntity, TFilter extends IBaseFilter, TService> implements OnInit {
  public page: IPageResult<TEntity> = {
    items: [],
    total: 0,
  };

  public tasks: any[] = [];
  public isLoading: boolean = false;
  public isLoaded: boolean = false;
  public filterVal: any;
  public filter: Subject<TFilter>;
  public filterParam: any = null;
  public isSearchPressed: boolean = false;
  public isDownloadComplete: boolean = true;

  public pageSummary: IPageResult<any> = {
    items: [],
    total: 0,
  };

  public isLoadedSummary: boolean = false;
  public filterValSummary: any;
  public filterSummary: Subject<any>;
  public showProgressBar: boolean;
  public progressBarTitle: string;
  public httpSubscription: Subscription;

  constructor(
    public reportService: ReportService<TEntity, TFilter>,
    public isLoadSummary: boolean,
    private eventService?: EventService,
  ) {
    this.progressBarTitle = 'Processing your request';
  }

  ngOnInit() {
    this.loadFilterParam();
    this.initDefaultFilter();

    this.filter = new Subject<TFilter>();
    this.filterSummary = new Subject<any>();

    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filterSummary.pipe(debounceTime(500)).subscribe((f) => {
      this.loadSummary(f);
      this.filterValSummary = f;
    });

    //    this.filter.next(this.filterVal);
    //    this.filterSummary.next(this.filterValSummary);
  }

  public loadFilterParam() {
    this.reportService
      .loadFilterParam()
      .then((result) => {
        this.filterParam = result;
        this.callbackLoadFilterParam();
      })
      .catch((ex) => {});
  }

  public callbackLoadFilterParam() {}

  public initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {},
    };

    this.filterValSummary = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {},
    };
  }

  load(filter: TFilter) {
    this.isLoading = true;
    this.httpSubscription = this.reportService.getPageAsObservable(flatten(filter)).subscribe(
      (result) => {
        var max = 0;
        result.items.forEach((x) => {
          var item = <any>x;
          if (item.tasks && item.tasks.length > max) {
            max = item.tasks.length;
          }
        });

        this.tasks = new Array(max);

        this.page.items = result.items;
        this.page.total = result.total;
        this.isLoaded = true;

        if (this.eventService != null) {
          this.eventService.ReportChangedEvent.emit(this.page);
        }
      },
      (err) => {},
      () => {
        this.isLoading = false;
      },
    );
  }

  onGridLazyLoad(event: LazyLoadEvent, callback?: (x: IPageResult<TEntity>) => void) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    // map grid lazy load event to filter
    if (this.isSearchPressed) {
      this.filter.next(this.filterVal);
    }
  }

  loadSummary(filter: any) {
    if (this.isLoadSummary) {
      filter.filters = this.filterVal.filters;

      this.reportService
        .getSummaryPage(filter)
        .then((result) => {
          this.pageSummary.items = result.items;
          this.pageSummary.total = result.total;
          this.isLoadedSummary = true;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  onGridSummaryLazyLoad(event: LazyLoadEvent) {
    this.filterValSummary.first = event.first;
    this.filterValSummary.rows = event.rows;

    if (this.isSearchPressed) {
      this.filterSummary.next(this.filterValSummary);
    }
  }

  search() {
    this.isSearchPressed = true;
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filterValSummary.first = 0;
    this.filter.next(this.filterVal);
    this.filterSummary.next(this.filterValSummary);
  }

  cancel() {
    this.httpSubscription.unsubscribe();
    this.isLoading = false;
  }

  clearFilter(table: any) {
    table.sortField = '';
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
    if (this.isLoadSummary) {
      this.filterSummary.next(this.filterValSummary);
    }
  }

  downloadReport(fileName?: string) {
    return this.reportService.downloadReport(flatten(this.filterVal), fileName);
  }

  ngOnDestroy() {
    if (this.httpSubscription) {
      this.httpSubscription.unsubscribe();
    }
  }
}
